import Modal from "react-bootstrap/Modal";
import PropTypes from "prop-types";
import RenderFields from "../RenderFields";
import { useSelector } from "react-redux";
import { Row } from "react-bootstrap";
import { toast } from "react-toastify";
import { containsSQLInjectionChars, getSQLInjectionMessage, sanitizeInput } from "../../../utills/useCryptoUtils";
import { Label } from "reactstrap";
import { type } from "os";

function CustomPopupModal({
  isCustomPopup,
  setIsCustomPopup,
  handleConfirm,
  section = [],
  formData,
  setFormData,
  moduleType,
  filterMasterOptions = [],
  chartData = [],
  isViewOnly
}) {
  const session = useSelector((state) => state.session);
  const user = session.user;
  const onHandleCloseFunc = () => {
    setIsCustomPopup(false)
  }

  const handleCustomFieldChange = (
    sectionIndex,
    fieldName,
    value,
    type = ""
  ) => {
    if (containsSQLInjectionChars(value, type)) {
      toast.error(getSQLInjectionMessage(), {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      return;
    }
    value = sanitizeInput(value, type);
    setFormData((prevFormData) => {
      return {
        ...prevFormData,
        [sectionIndex]: {
          ...prevFormData[sectionIndex],
          [fieldName]: value,
        },
      };
    });
  }

  const getCustomCellValues = (cell) => {
    if (["PoPreview", 'purchaseReq'].includes(moduleType)) {
      if (['req_fk_approval_id', 'fk_approval_id'].includes(cell.name)) {
        // cell.includesData = [
        //   "T10075",
        //   "T10249",
        //   "SU2005",
        //   "P10115",
        //   user?.all_roles?.usr_emp_id_orig
        // ]
        cell.defaultValue = user?.all_roles?.usr_emp_id_orig
      }

    }
    else if (['analytics'].includes(moduleType)) {
      if (cell.name === "sales_per_id") {
        if (formData?.[0]?.export_type === "Invoice") {

          cell.options = chartData.map((data) => {
            if (data.category) {
              return {
                label: data.category,
                value: data.id
              }
            }
          })
          cell.defaultValue = formData?.[0]?.sales_per_id ? formData[0].sales_per_id : chartData?.[0]?.id
        }
      }
    }
    if (isViewOnly) {
      cell = {
        ...cell,
        readOnly: true,
        viewOnly: true,
        isDisabledField: true,
        type: ["DropDownWithLoadMore", "select"].includes(cell.type) ? "label" : cell.type
      }
    }
    return cell;
  }
  const isShowField = (cell) => {
    if (['analytics'].includes(moduleType)) {
      if (cell.name === "sales_per_id") {
        if (formData?.[0]?.export_type !== "Invoice") {
          return false
        }
      }
    }
    if (["purchaseItems"].includes(section.moduleType)) {
      if (
        cell.isCallibrationField &&
        ![
          formData[0]?.item_services,
          formData[0]?.stock_services,
        ].includes("Calibration")
      ) {
        return false
      }
      if (
        cell.isAMCField &&
        ![
          formData[0]?.item_services,
          formData[0]?.stock_services,
        ].includes("AMC")
      ) {
        return false
      }
    }
    return true
  }
  return (
    <span>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={isCustomPopup}
        onHide={() => onHandleCloseFunc()}
      >
        <Modal.Body className="popup_body">
          <div className={`popupSearchContainerBG ${isViewOnly ? 'customPopupViewClass' : ''}`}>
            <div className={`popupSearchContainer popupWidthAdjustment ${section.isFullform ? "popupWidthAdjustmentFullShow" : ''}`}>
              <div className="rejectSearchCross">
                <button onClick={() => onHandleCloseFunc()} className="nonNativeButton2" aria-label="Reject Button">
                  <i className="bi bi-x-lg h4"></i>
                </button>
              </div>
              <div className="cpm-header">
                <div className="cpm-header-icon" aria-hidden="true">
                  <i className={`bi ${section.icon || "bi-file-earmark-text"}`}></i>
                </div>
                <div className="cpm-header-text">
                  <h2 id="custom-popup-title" className="cpm-title">{section.title}</h2>
                  {section.subtitle && <p className="cpm-subtitle">{section.subtitle}</p>}
                </div>
              </div>
              <div className="popupSearchGroupContainer">
                <Row>
                  {
                    section.fields.map((field, fieldIndex) => {
                      return isShowField(field) ? (
                        <div
                          key={"Form-Extra-Adjustments" + fieldIndex}
                          className={"col-md-" + field.width}
                        >

                          <RenderFields
                            field={getCustomCellValues(field)}
                            sectionIndex={0}
                            fieldIndex={fieldIndex}
                            formData={formData}
                            handleFieldChange={handleCustomFieldChange}
                            setFormData={setFormData}
                            masterOptions={filterMasterOptions}
                          />
                        </div>
                      ) : null
                    })
                  }
                </Row>
              </div>
              <div className="rejectButtonsContainer">
                <div className="popupSearchButtons">
                  <button type="button" onClick={() => onHandleCloseFunc()}>
                    {section?.buttons?.cancel?.title || "Cancel"}
                  </button>
                  {!isViewOnly && <button type="button" onClick={handleConfirm}>
                    {section?.buttons?.confirm?.title || "Cancel"}
                  </button>}
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </span>
  );
}
CustomPopupModal.propTypes = {
  isCustomPopup: PropTypes.bool.isRequired,
  setIsCustomPopup: PropTypes.func.isRequired,
  handleConfirm: PropTypes.func.isRequired,
  popupMessage: PropTypes.string,
  popupHeading: PropTypes.string,
  setRemarkText: PropTypes.func.isRequired,
  remarkText: PropTypes.string,
};
export default CustomPopupModal;
